<template>
  <div class="home">
    <HomeHeader />
    <!-- Hero Section com Efeito Parallax -->
    <section class="hero-section">
    <div
      class="parallax-container"
      :style="{ backgroundImage: 'url(/assets/banner-inicio.jpg)' }"
    >
      <div class="overlay"></div>

      <!-- Modelo anterior (texto + botões à esquerda + ícone-logo à direita) — comentado para teste do novo modelo centralizado com a logomarca vertical
      <div class="hero-content">
        <div class="hero-badge">
          <i class="fas fa-map-marker-alt"></i>
          <span>Recife, PE — para todo o Brasil</span>
        </div>
        <h2 class="banner-h2" v-html="t('home.hero.title')"></h2>
        <p class="banner-p" v-html="t('home.hero.subtitle')"></p>
        <div class="hero-buttons">
          <router-link to="/SejaParceiro" class="hero-btn hero-btn-primary">
            <span>Quero ser parceiro</span>
          </router-link>
          <router-link to="/Sobre" class="hero-btn hero-btn-outline">
            <span>Conheça a UNI</span>
          </router-link>
        </div>
      </div>

      <div class="hero-icon-logo"></div>
      -->

      <div class="hero-center">
        <img
          class="hero-center-logo"
          src="@/assets/uni-logo-vertical-branco-principal.svg"
          alt="Uni Hospitalar"
        />
        <p class="hero-center-tagline" v-html="t('home.hero.title')"></p>
      </div>

      <div class="scroll-indicator" @click="scrollToContent">
        <span>{{ t('home.hero.scrollIndicator') }}</span>
        <i class="fas fa-chevron-down"></i>
      </div>
    </div>
  </section>

    <!-- Seção de Estatísticas -->
    <section class="stats-section" ref="statsSection">
      <div class="stats-watermark stats-watermark-1"></div>
      <div class="stats-watermark stats-watermark-2"></div>
      <div class="container">
        <div class="section-header">
          <h2 v-html="t('home.stats.title')"></h2>
          <div class="accent-line"></div>
        </div>
        <div class="stats-grid">
          <div class="stat-card">
            <div class="stat-icon">
              <i class="fas fa-calendar-alt"></i>
            </div>
            <div class="stat-number">
              <span ref="yearsCounter" :data-target="yearsOfExperience">0</span>
            </div>
            <div class="stat-label" v-html="t('home.stats.years')"></div>
          </div>
          <div class="stat-card">
            <div class="stat-icon">
              <i class="fas fa-map-marker-alt"></i>
            </div>
            <div class="stat-number">
              <span ref="unitsCounter" data-target="3">0</span>
            </div>
            <div class="stat-label" v-html="t('home.stats.units')"></div>
          </div>
          <div class="stat-card">
            <div class="stat-icon">
              <i class="fas fa-map-marked-alt"></i>
            </div>
            <div class="stat-number">
              <span ref="statesCounter" data-target="26">0</span>
            </div>
            <div class="stat-label" v-html="t('home.stats.presenceText')"></div>
          </div>
          <div class="stat-card">
            <div class="stat-icon">
              <i class="fas fa-truck"></i>
            </div>
            <div class="stat-number">
              <span ref="hoursCounter" data-target="24">0</span>h
            </div>
            <div class="stat-label" v-html="t('home.stats.delivery')"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- Seção de Serviços e Informações -->
    <!-- <section class="services-section">
       <div class="container">
         <ScrollReveal direction="bottom" :delay="100">
           <div class="section-header">
             <h2 class="section-title">{{ t('home.services.title') }}</h2>
             <div class="section-subtitle">{{ t('home.services.subtitle') }}</div>
             <div class="accent-line"></div>
           </div>
         </ScrollReveal> -->

    <!-- Cards de serviços - Primeira linha -->
    <!-- <div class="services-grid">
           <ScrollReveal direction="left" :delay="200">
             <div class="service-card">
               <div class="service-image">
                 <img src="@/assets/estoque.jpg" alt="Estoque" @error="handleImageError($event, 'estoque')">
                 <div class="service-overlay"></div>
               </div>
               <div class="service-content">
                 <div class="service-icon">
                   <i class="fas fa-warehouse"></i>
                 </div>
                 <h3>{{ t('home.services.storage.title') }}</h3>
                 <p>{{ t('home.services.storage.description') }}</p>
                 <router-link to="/Diferenciais" class="service-link">
                   <span>{{ t('home.services.storage.link') }}</span>
                   <i class="fas fa-long-arrow-alt-right"></i>
                 </router-link>
               </div>
             </div>
           </ScrollReveal>
  
           <ScrollReveal direction="bottom" :delay="300">
             <div class="service-card">
               <div class="service-image">
                 <img src="@/assets/diferenciais.jpg" alt="Diferenciais"
                   @error="handleImageError($event, 'diferenciais')">
                 <div class="service-overlay"></div>
               </div>
               <div class="service-content">
                 <div class="service-icon">
                   <i class="fas fa-award"></i>
                 </div>
                 <h3>{{ t('home.services.differentials.title') }}</h3>
                 <p>{{ t('home.services.differentials.description') }}</p>
                 <router-link to="/Diferenciais" class="service-link">
                   <span>{{ t('home.services.differentials.link') }}</span>
                   <i class="fas fa-long-arrow-alt-right"></i>
                 </router-link>
               </div>
             </div>
           </ScrollReveal>
  
           <ScrollReveal direction="right" :delay="200">
             <div class="service-card">
               <div class="service-image">
                 <img src="@/assets/logistica.jpg" alt="Logística" @error="handleImageError($event, 'logistica')">
                 <div class="service-overlay"></div>
               </div>
               <div class="service-content">
                 <div class="service-icon">
                   <i class="fas fa-truck-loading"></i>
                 </div>
                 <h3>{{ t('home.services.logistics.title') }}</h3>
                 <p>{{ t('home.services.logistics.description') }}</p>
                 <router-link to="/Diferenciais" class="service-link">
                   <span>{{ t('home.services.logistics.link') }}</span>
                   <i class="fas fa-long-arrow-alt-right"></i>
                 </router-link>
               </div>
             </div>
           </ScrollReveal>
         </div> -->

    <!-- Cards de serviços - Segunda linha -->
    <!-- <div class="services-grid">
           <ScrollReveal direction="left" :delay="300">
             <div class="service-card">
               <div class="service-image">
                 <img src="@/assets/unidade-de-negocios.jpg" alt="Unidade de Negócios">
                 <div class="service-overlay"></div>
               </div>
               <div class="service-content">
                 <div class="service-icon">
                   <i class="fas fa-building"></i>
                 </div>
                 <h3>{{ t('home.services.businessUnit.title') }}</h3>
                 <p>{{ t('home.services.businessUnit.description') }}</p>
                 <router-link to="/Diferenciais" class="service-link">
                   <span>{{ t('home.services.businessUnit.link') }}</span>
                   <i class="fas fa-long-arrow-alt-right"></i>
                 </router-link>
               </div>
             </div>
           </ScrollReveal>
  
           <ScrollReveal direction="bottom" :delay="400">
             <div class="service-card">
               <div class="service-image">
                 <img src="@/assets/principais-clientes.jpg" alt="Principais Clientes">
                 <div class="service-overlay"></div>
               </div>
               <div class="service-content">
                 <div class="service-icon">
                   <i class="fas fa-users"></i>
                 </div>
                 <h3>{{ t('home.services.mainClients.title') }}</h3>
                 <p>{{ t('home.services.mainClients.description') }}</p>
                 <router-link to="/Parceiros" class="service-link">
                   <span>{{ t('home.services.mainClients.link') }}</span>
                   <i class="fas fa-long-arrow-alt-right"></i>
                 </router-link>
               </div>
             </div>
           </ScrollReveal>
  
           <ScrollReveal direction="right" :delay="300">
             <div class="service-card">
               <div class="service-image">
                 <img src="@/assets/principais-produtos.jpg" alt="Principais Produtos">
                 <div class="service-overlay"></div>
               </div>
               <div class="service-content">
                 <div class="service-icon">
                   <i class="fas fa-pills"></i>
                 </div>
                 <h3>{{ t('home.services.mainProducts.title') }}</h3>
                 <p>{{ t('home.services.mainProducts.description') }}</p>
                 <router-link to="/Produtos" class="service-link">
                   <span>{{ t('home.services.mainProducts.link') }}</span>
                   <i class="fas fa-long-arrow-alt-right"></i>
                 </router-link>
               </div>
             </div>
           </ScrollReveal>
         </div>
       </div>
     </section> -->

    <!-- Seção de Depoimentos -->
    <!-- <section class="testimonials-section">
       <div class="container">
         <ScrollReveal direction="bottom" :delay="100">
           <div class="section-header">
             <h2 class="section-title">{{ t('home.testimonials.title') }}</h2>
             <div class="section-subtitle">{{ t('home.testimonials.subtitle') }}</div>
             <div class="accent-line"></div>
           </div>
         </ScrollReveal>
         <div class="testimonials-slider">
           <div class="testimonials-slides" @touchstart="handleTouchStart" @touchmove.passive="handleTouchMove"
             @touchend="handleTouchEnd" @mousedown="handleMouseDown" @mousemove="handleMouseMove"
             @mouseup="handleMouseUp" @mouseleave="handleMouseUp" :style="{ transform: `translateX(${slideOffset}px)` }">
             <div v-for="(testimonial, index) in testimonials" :key="index" class="testimonial-slide"
               :class="{ active: currentTestimonial === index }">
               <div class="testimonial-content">
                 <div class="quote-icon">
                   <i class="fas fa-quote-left"></i>
                 </div>
                 <p class="testimonial-text">{{ testimonial.text }}</p>
                 <div class="testimonial-author">
                   <div class="author-avatar">
                     <i :class="getAuthorIcon(index)"></i>
                   </div>
                   <div class="author-info">
                     <div class="author-name">{{ testimonial.author }}</div>
                     <div class="author-position">{{ testimonial.position }}</div>
                   </div>
                 </div>
  
                 <div class="testimonial-controls">
                   <button class="control-prev" @click="prevTestimonial">
                     <i class="fas fa-chevron-left"></i>
                   </button>
                   <div class="control-indicators">
                     <span v-for="(testimonialItem, indicatorIndex) in testimonials" :key="indicatorIndex"
                       class="indicator" :class="{ active: currentTestimonial === indicatorIndex }"
                       @click="setTestimonial(indicatorIndex)"></span>
                   </div>
                   <button class="control-next" @click="nextTestimonial">
                     <i class="fas fa-chevron-right"></i>
                   </button>
                 </div>
               </div>
             </div>
           </div>
         </div>
       </div>
     </section> -->

    <!-- Seção de Parceiros -->
    <section class="partners-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">{{ t('home.partners.title') }}</h2>
          <div class="section-subtitle">{{ t('home.partners.subtitle') }}</div>
          <div class="accent-line"></div>
        </div>

        <div class="partners-carousel">
          <div class="partners-track">
            <!-- Primeira passagem de todos os parceiros -->
            <div v-for="n in partnerNumbers" :key="`first-${n}`" class="partner-slide">
              <img :src="require(`@/assets/parceiro${n}.jpg`)" :alt="`Parceiro ${n}`" :class="`partner-${n}`"
                @error="handleImageError">
            </div>

            <!-- Segunda passagem para criar o loop infinito -->
            <div v-for="n in partnerNumbers" :key="`second-${n}`" class="partner-slide">
              <img :src="require(`@/assets/parceiro${n}.jpg`)" :alt="`Parceiro ${n}`" :class="`partner-${n}`"
                @error="handleImageError">
            </div>
          </div>
        </div>

        <div class="partners-action">
          <router-link to="/Parceiros">
            <button class="secondary-button">
              <span>{{ t('home.partners.button') }}</span>
              <i class="fas fa-arrow-right"></i>
            </button>
          </router-link>
        </div>
      </div>
    </section>

    <!-- Seção de Chamada para Ação -->
    <section class="cta-section">
      <div class="cta-watermark"></div>
      <div class="container">
        <div class="cta-container">
          <h2>{{ t('home.cta.title') }}</h2>
          <p>{{ t('home.cta.description') }}</p>
          <router-link to="/SejaParceiro">
            <button class="cta-button">
              <span>{{ t('home.cta.button') }}</span>
              <i class="fas fa-handshake"></i>
            </button>
          </router-link>
        </div>
      </div>
    </section>

    <!-- Seção de Contato Rápido -->
    <section class="quick-contact-section">
      <div class="container">
        <div class="quick-contact-container">
          <div class="contact-info">
            <h2>{{ t('home.contact.title') }}</h2>
            <p>{{ t('home.contact.subtitle') }}</p>

            <!-- Botões para selecionar filial -->
            <div class="branch-selector">
              <button v-for="(branch, index) in branches" :key="index" @click="setActiveBranch(index)"
                :class="['branch-button', { active: activeBranch === index }]">
                {{ getBranchName(index) }}
              </button>
            </div>

            <!-- Informações da filial selecionada -->
            <div class="branch-info">
              <div class="contact-methods">
                <div class="contact-method">
                  <i class="fas fa-phone-alt"></i>
                  <span>{{ branches[activeBranch].phone }}</span>
                </div>
                <div class="contact-method">
                  <i class="fas fa-id-card"></i>
                  <span>CNPJ: {{ branches[activeBranch].cnpj }}</span>
                </div>
                <div class="contact-method">
                  <i class="fas fa-envelope"></i>
                  <a href="mailto:contato@unihospitalar.com.br" class="email-link">
                    {{ branches[activeBranch].email }}
                  </a>
                </div>
                <div class="contact-method">
                  <i class="fas fa-map-marker-alt"></i>
                  <span>{{ branches[activeBranch].address }}</span>
                </div>
                <div class="contact-method">
                  <i class="fas fa-clock"></i>
                  <span>{{ t('home.contact.hours') }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Mapa da filial selecionada -->
          <div class="branch-map">
            <iframe :src="branches[activeBranch].mapUrl" width="100%" height="100%" style="border:0;" allowfullscreen=""
              loading="lazy" referrerpolicy="no-referrer-when-downgrade">
            </iframe>
          </div>
        </div>
      </div>
    </section>

    <HomeFooter />
  </div>
</template>

<script>
import HomeHeader from '@/components/HomeHeader.vue';
import HomeFooter from '@/components/HomeFooter.vue';
import { useHomeTranslation } from '@/composables/useHomeTranslation.js';
import { useJobsStore } from '@/composables/useJobsStore.js'

export default {
  name: 'HomePrincipal',
  components: {
    HomeHeader,
    HomeFooter
  },
  setup() {
    const { t, currentLanguage } = useHomeTranslation()
    const { preloadJobs } = useJobsStore()

    return {
      t,
      currentLanguage,
      preloadJobs
    }
  },
  data() {
    return {
      totalPartners: 33, // Total de imagens de parceiros (parceiro1.jpg até parceiro33.jpg)
      currentTestimonial: 0,
      testimonialInterval: null,
      partnersAnimation: null, // Para controlar a animação dos parceiros
      activeBranch: 0,
      companyFoundingYear: 2005, // Ano de fundação da empresa
      companyAnniversary: { month: 7, day: 11 }, // 11 de julho
      isDragging: false,
      startX: 0,
      currentX: 0,
      slideOffset: 0,
      dragThreshold: 50,
      branches: [
        {
          name: 'Uni Hospitalar',
          cnpj: '07.484.373/0001-24',
          phone: '+55 (81) 3472-7201',
          email: 'contato@unihospitalar.com.br',
          address: 'R. Alagoas, 253 - Ipsep, Recife - PE, 51350-560',
          hours: 'Segunda a Sexta: 8h às 18h',
          mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d246.91!2d-34.8951233!3d-8.0623376!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7ab1be2a5d9b3d7%3A0x123456789!2sR.%20Alagoas%2C%20253%20-%20Ipsep%2C%20Recife%20-%20PE%2C%2051350-560%2C%20Brasil!5e0!3m2!1spt-BR!2sbr!4v1699999999999!5m2!1spt-BR!2sbr'
        },
        {
          name: 'Uni Hospitalar Ceará',
          cnpj: '21.595.464/0001-68',
          phone: '+55 (85) 3289-3722',
          email: 'contato@uniceara.com.br',
          address: 'Rua Flôres, 38 - Cajazeiras, Fortaleza - CE, 60864-520',
          hours: 'Segunda a Sexta: 8h às 18h',
          mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d124.37358531027889!2d-38.58232312426936!3d-3.8271872440876074!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7c74c7a7a7a7a7a7%3A0x9e3e5b0d8d3d8d3d!2sR.%20Fl%C3%B4res%2C%2038%20-%20Cajazeiras%2C%20Fortaleza%20-%20CE%2C%2060864-510!5e0!3m2!1spt-BR!2sbr!4v1625151234567!5m2!1spt-BR!2sbr'
        },
        {
          name: 'SP Hospitalar',
          cnpj: '27.817.504/0001-55',
          phone: '+55 (11) 4777-2159',
          email: 'contato@sphospitalar.com.br',
          address: 'R. Pinhal, 165 - Jardim Sabiá, Cotia - SP, 06716-575',
          hours: 'Segunda a Sexta: 8h às 18h',
          mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d228.58726956298115!2d-46.92011492368744!3d-23.55290096159868!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94cf03b8b1b8b8b9%3A0x9e3e5b0d8d3d8d3d!2sR.%20Pinhal%2C%20165%20-%20Jardim%20Sabi%C3%A1%2C%20Cotia%20-%20SP%2C%2006716-575!5e0!3m2!1spt-BR!2sbr!4v1625151234567!5m2!1spt-BR!2sbr'
        }
      ]
      };
      },
  computed: {
    partnerNumbers() {
      const removed = [2, 19]; // parceiro2.jpg e parceiro19.jpg não são mais parceiros
      const numbers = [];
      for (let n = 1; n <= this.totalPartners; n++) {
        if (!removed.includes(n)) numbers.push(n);
      }
      return numbers;
    },
    yearsOfExperience() {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth() + 1;
      const currentDay = today.getDate();

      let years = currentYear - this.companyFoundingYear;

      // Se ainda não passou do aniversário deste ano, subtrai 1
      if (currentMonth < this.companyAnniversary.month ||
        (currentMonth === this.companyAnniversary.month && currentDay < this.companyAnniversary.day)) {
        years--;
      }

      return years;
    },
    testimonials() {
      return [
        {
          text: this.t('home.testimonials.testimonial1.text'),
          author: this.t('home.testimonials.testimonial1.author'),
          position: this.t('home.testimonials.testimonial1.position')
        },
        {
          text: this.t('home.testimonials.testimonial2.text'),
          author: this.t('home.testimonials.testimonial2.author'),
          position: this.t('home.testimonials.testimonial2.position')
        },
        {
          text: this.t('home.testimonials.testimonial3.text'),
          author: this.t('home.testimonials.testimonial3.author'),
          position: this.t('home.testimonials.testimonial3.position')
        }
      ]
    }
  },
  mounted() {
    this.startTestimonialSlider();
    this.setupIntersectionObserver();
    this.preloadJobs();
    this.startPartnersCarousel(); // Iniciar animação do carrossel de parceiros
    },
    beforeUnmount() {
    clearInterval(this.testimonialInterval);
    if (this.partnersAnimation) {
      this.partnersAnimation.cancel();
    }
    },
  methods: {
    scrollToContent() {
      this.$refs.statsSection.scrollIntoView({ behavior: 'smooth' });
    },
    setupIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.3
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.animateCounters();
            observer.unobserve(entry.target);
          }
        });
      }, options);

      observer.observe(this.$refs.statsSection);
    },

    animateCounters() {
      const baseDuration = 6000;

      const counters = [
        { ref: this.$refs.yearsCounter, target: this.yearsOfExperience },
        { ref: this.$refs.unitsCounter, target: 3 },
        { ref: this.$refs.statesCounter, target: 26 },
        { ref: this.$refs.hoursCounter, target: 24 }
      ];

      counters.forEach(counter => {
        counter.ref.innerText = '0';
        counter.current = 0;
      });

      const steps = Math.floor(baseDuration / 16);
      let currentStep = 0;

      const animate = () => {
        currentStep++;
        const progress = currentStep / steps;

        counters.forEach(counter => {
          const easedProgress = 1 - Math.pow(1 - progress, 3);
          const value = Math.min(
            Math.floor(counter.target * easedProgress),
            counter.target
          );

          if (value !== counter.current) {
            counter.ref.innerText = value;
            counter.current = value;
          }
        });

        if (currentStep < steps) {
          requestAnimationFrame(animate);
        } else {
          counters.forEach(counter => {
            counter.ref.innerText = counter.target;
          });
        }
      };

      requestAnimationFrame(animate);
    },

    startTestimonialSlider() {
      this.testimonialInterval = setInterval(() => {
        this.nextTestimonial();
      }, 5000);
    },
    prevTestimonial() {
      clearInterval(this.testimonialInterval);
      this.currentTestimonial = (this.currentTestimonial - 1 + this.testimonials.length) % this.testimonials.length;
      this.startTestimonialSlider();
    },
    nextTestimonial() {
      this.currentTestimonial = (this.currentTestimonial + 1) % this.testimonials.length;
    },
    setTestimonial(index) {
      clearInterval(this.testimonialInterval);
      this.currentTestimonial = index;
      this.startTestimonialSlider();
    },
    getAuthorIcon(index) {
      const icons = ['fas fa-user-md', 'fas fa-user-nurse', 'fas fa-user-tie'];
      return icons[index] || 'fas fa-user';
    },
    getBranchName(index) {
      const branchKeys = ['home.contact.branches.recife', 'home.contact.branches.fortaleza', 'home.contact.branches.saopaulo'];
      return this.t(branchKeys[index]) || this.branches[index].name;
    },
    handleImageError(e) {
      e.target.src = require('@/assets/uni-logo-horizontal-bordo.svg');
    },
    setActiveBranch(index) {
      this.activeBranch = index;
    },
    handleTouchStart(e) {
      this.startDrag(e.touches[0].clientX);
    },

    handleTouchMove(e) {
      if (this.isDragging) {
        e.preventDefault();
        this.updateDrag(e.touches[0].clientX);
      }
    },

    handleTouchEnd() {
      this.endDrag();
    },

    handleMouseDown(e) {
      this.startDrag(e.clientX);
    },

    handleMouseMove(e) {
      if (this.isDragging) {
        e.preventDefault();
        this.updateDrag(e.clientX);
      }
    },

    handleMouseUp() {
      this.endDrag();
    },

    startDrag(clientX) {
      this.isDragging = true;
      this.startX = clientX;
      this.currentX = clientX;
      clearInterval(this.testimonialInterval);
    },

    updateDrag(clientX) {
      if (!this.isDragging) return;

      this.currentX = clientX;
      const deltaX = this.currentX - this.startX;
      this.slideOffset = deltaX;
    },

    endDrag() {
      if (!this.isDragging) return;

      const deltaX = this.currentX - this.startX;

      if (Math.abs(deltaX) > this.dragThreshold) {
        if (deltaX > 0) {
          this.prevTestimonial();
        } else {
          this.nextTestimonial();
        }
      }

      this.isDragging = false;
      this.slideOffset = 0;
      this.startTestimonialSlider();
    },

    startPartnersCarousel() {
      this.$nextTick(() => {
        const track = document.querySelector('.partners-track');
        if (!track) return;

        // Calcular a largura total do conteúdo dividido por 2
        const contentWidth = track.scrollWidth / 2;

        // Animação contínua da direita para a esquerda
        this.partnersAnimation = track.animate([
          { transform: 'translateX(0px)' },
          { transform: `translateX(-${contentWidth}px)` }
        ], {
          duration: 50000, // 50 segundos para completar o ciclo
          iterations: Infinity,
          easing: 'linear'
        });
      });
    }
  }
};
</script>

<style scoped>
/* Estilos Gerais */
.home {
  font-family: 'Matter', 'Segoe UI', Arial, sans-serif;
  color: #333;
  overflow-x: hidden;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

section {
  padding: 80px 0;
  position: relative;
}

/* Hero Section com Parallax */
.hero-section {
  position: relative;
  height: 100vh;
  min-height: 600px;
  overflow: hidden;
  margin-top: -80px;
  border-bottom: 4px solid #470404;
}

.parallax-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
  color: white;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgba(48, 3, 3, 0.92) 0%, rgba(71, 4, 4, 0.8) 58%, rgba(71, 4, 4, 0.4) 100%);
}

/* .overlay::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 480px;
  height: 480px;
  background-image: url('@/assets/uni-simbolo-bordo.svg');
  background-repeat: no-repeat;
  background-position: right -80px top -60px;
  background-size: 420px;
  opacity: 0.06;
} */

.hero-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 20px;
  max-width: 600px;
  width: 100%;
  margin-left: 11%;
  animation: fadeIn 1.5s ease-in-out;
}

/* Novo modelo de teste: logomarca vertical centralizada + tagline junto */
.hero-center {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: center;
  text-align: center;
  width: 100%;
  padding: 20px;
  animation: fadeIn 1.5s ease-in-out;
}

.hero-center-logo {
  width: 100%;
  max-width: 340px;
  height: auto;
  filter: drop-shadow(0 4px 20px rgba(0, 0, 0, 0.35));
  animation: fadeInUp 1.5s ease-out;
}

.hero-center-tagline {
  margin-top: 24px;
  color: #ffffff;
  font-size: 1.3em;
  font-weight: 600;
  letter-spacing: 0.3px;
  line-height: 1.4;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.45);
  max-width: 560px;
  animation: fadeInUp 1.5s ease-out 0.3s both;
}

@media (max-width: 768px) {
  .hero-center-logo {
    max-width: 240px;
  }

  .hero-center-tagline {
    font-size: 1.1em;
    padding: 0 10px;
  }
}

@media (max-width: 400px) {
  .hero-center-logo {
    max-width: 180px;
  }

  .hero-center-tagline {
    font-size: 1em;
  }
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.35);
  color: #ffffff;
  padding: 8px 18px;
  border-radius: 30px;
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin-bottom: 24px;
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.4);
  animation: fadeInUp 1.5s ease-out;
}

.hero-badge i {
  color: #931414;
}

.banner-h2 {
  font-size: 2.6em;
  margin: 0 0 0.4em 0;
  font-weight: 800;
  color: #ffffff;
  position: relative;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.4);
  border-radius: 2px;
  display: block;
  letter-spacing: 0.5px;
  line-height: 1.2;
  animation: fadeInUp 1.5s ease-out 0.3s both;
}

.banner-p {
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.15em;
  margin-bottom: 1.8em;
  line-height: 1.6;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.4);
  font-weight: 400;
  letter-spacing: 0.2px;
  max-width: 100%;
  padding: 0;
  border-left: none;
  animation: fadeInUp 1.5s ease-out 0.6s both;
}

.hero-buttons {
  display: flex;
  gap: 18px;
  flex-wrap: wrap;
  animation: fadeInUp 1.5s ease-out 0.9s both;
}

.hero-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 14px 30px;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease, transform 0.3s ease;
  letter-spacing: 0.3px;
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
}

/* Liquid Glass — mesmo material do navbar, tingido de bordô no botão principal */
.hero-btn-primary {
  background-color: rgba(71, 4, 4, 0.45);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 20px rgba(71, 4, 4, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.25);
}

.hero-btn-primary:hover {
  background-color: rgba(71, 4, 4, 0.65);
  transform: translateY(-3px);
  box-shadow: 0 12px 25px rgba(71, 4, 4, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.hero-btn-outline {
  background-color: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.25);
}

.hero-btn-outline:hover {
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.7);
  transform: translateY(-3px);
}

/* Ícone-logo dourado, aproveitando o espaço vazio à direita do banner */
.hero-icon-logo {
  position: absolute;
  top: 22%;
  right: 6%;
  width: 700px;
  height: 700px;
  transform: translateY(-50%);
  background-image: url('@/assets/uni-simbolo-principal.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.4;
  filter: saturate(0.85);
  z-index: 1;
  pointer-events: none;
  animation: float 6s ease-in-out infinite;
}

@media (max-width: 1700px) {
  .hero-icon-logo {
    width: 600px;
    height: 600px;
  }
}

@media (max-width: 1500px) {
  .hero-icon-logo {
    width: 480px;
    height: 480px;
    right: 4%;
  }
}

@media (max-width: 1300px) {
  .hero-icon-logo {
    width: 400px;
    height: 400px;
  }
}

@media (max-width: 1200px) {
  .hero-icon-logo {
    width: 320px;
    height: 320px;
    top: 30%;
  }
}

@media (max-width: 992px) {
  .hero-icon-logo {
    display: none;
  }
}

.scroll-indicator {
  position: absolute;
  bottom: 86px;
  left: 0;
  right: 0;
  width: fit-content;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  padding: 10px 20px;
  border-radius: 30px;
  background: rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
  animation: bounce 2s infinite, glow 2s infinite alternate;
  z-index: 10;
}

.scroll-indicator span {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
}

.scroll-indicator i {
  font-size: 20px;
  margin-top: 5px;
}

.scroll-indicator:hover {
  transform: translateY(-5px);
  background-color: rgba(71, 4, 4, 1);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
}

/* Seção de Estatísticas */
.stats-section {
  background: #F0F0F0;
  padding: 100px 0;
  position: relative;
  overflow: hidden;
}

.stats-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: repeating-linear-gradient(45deg, rgba(71, 4, 4, 0.07) 0px, rgba(71, 4, 4, 0.07) 1px, transparent 1px, transparent 14px);
  pointer-events: none;
}

/* Símbolo da marca duplicado ao fundo, em escalas e posições diferentes,
   como referência de identidade visual (padrão do manual da marca) */
/* Símbolo em traço (stroke), sangrando pelos cantos e desvanecendo em
   degradê de opacidade — conforme manual de identidade (grafismo de fundo
   em grande escala, cortado nas extremidades, sem preenchimento) */
.stats-watermark {
  position: absolute;
  top: 0;
  width: 700px;
  height: 700px;
  background-image: url('@/assets/uni-simbolo-outline.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.22;
  pointer-events: none;
  z-index: 0;
}

.stats-watermark-1 {
  left: -181px;
  top: -203px;
  mask-image: linear-gradient(to bottom right, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.6) 55%, transparent 85%);
  -webkit-mask-image: linear-gradient(to bottom right, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.6) 55%, transparent 85%);
}

.stats-watermark-2 {
  right: -203px;
  left: auto;
  top: auto;
  bottom: -226px;
  mask-image: linear-gradient(to top left, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.6) 55%, transparent 85%);
  -webkit-mask-image: linear-gradient(to top left, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.6) 55%, transparent 85%);
}

/* Ajuste pra notebooks (telas 13"-15", viewport de altura baixa): mesmo em
   largura de desktop, as duas logos desmaiadas podem ficar apertadas
   quando a janela é baixa — some com a segunda, igual já fazemos em
   telas estreitas de celular */
@media (min-width: 769px) and (max-height: 820px) {
  .stats-watermark-2 {
    display: none;
  }
}

.stats-grid {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;
}

.stat-card {
  position: relative;
  background: #ffffff;
  border-top: 4px solid #931414;
  border-radius: 12px;
  padding: 35px 20px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
}

.stat-card .stat-icon {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #931414, #470404);
  color: #ffffff;
  font-size: 1.5rem;
  margin: 0 auto 20px;
  box-shadow: 0 8px 20px rgba(147, 20, 20, 0.3);
}

.stat-card .stat-number {
  font-size: 2.2rem;
  font-weight: 800;
  color: #931414;
  margin-bottom: 10px;
}

.stat-card .stat-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #555;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1.35;
}

.stats-section .section-header {
  text-align: center;
  margin-bottom: 50px;
}

.stats-section .section-header h2 {
  background: none;
  -webkit-text-fill-color: #470404;
  color: #470404;
  font-size: 2rem;
  margin-bottom: 0;
  white-space: nowrap;
}

.stats-section .accent-line {
  margin: 15px auto 0;
  background: linear-gradient(90deg, #470404, #931414);
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-header h2 {
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, #300303, #470404);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 15px;
  position: relative;
  display: inline-block;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 15px;
  position: relative;
  display: inline-block;
}

.section-subtitle {
  font-size: 1.2rem;
  color: #696969;
  margin-bottom: 20px;
}

.accent-line {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #470404, #931414);
  margin: 0 auto;
}

/* Seção de Serviços */
.services-section {
  background-color: #f0f0f0;
  padding: 100px 0;
  position: relative;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-bottom: 50px;
}

.service-card {
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
}

.service-image {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.service-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.service-card:hover .service-image img {
  transform: scale(1.1);
}

.service-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.6));
}

.service-content {
  padding: 30px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
}

.service-icon {
  width: 70px;
  height: 70px;
  background-color: #470404;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -65px auto 20px;
  position: relative;
  z-index: 2;
  box-shadow: 0 5px 15px rgba(71, 4, 4, 0.3);
  border: 5px solid #fff;
}

.service-icon i {
  font-size: 1.8rem;
  color: #fff;
}

.service-card h3 {
  font-size: 1.3rem;
  font-weight: 700;
  background: linear-gradient(135deg, #300303, #470404);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 15px;
  text-align: center;
}

.service-card p {
  color: #696969;
  line-height: 1.6;
  margin-bottom: 20px;
  flex-grow: 1;
  text-align: center;
}

.service-link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #470404;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.3s ease;
  margin-top: auto;
}

.service-link i {
  transition: transform 0.3s ease;
}

.service-link:hover {
  color: #931414;
}

.service-link:hover i {
  transform: translateX(5px);
}

/* Seção de Depoimentos */
.testimonials-section {
  background-color: #f0f0f0;
  position: relative;
  overflow: hidden;
  padding: 180px 0;
}

.testimonials-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: repeating-linear-gradient(45deg, rgba(240, 240, 240, 0.07) 0px, rgba(240, 240, 240, 0.07) 1px, transparent 1px, transparent 14px);
}

.testimonials-slider {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
}

.testimonials-slides {
  position: relative;
  min-height: 450px;
  margin-bottom: 30px;
}

.testimonial-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.5s ease, visibility 0.5s ease;
  z-index: 1;
}

.testimonial-slide.active {
  opacity: 1;
  visibility: visible;
  z-index: 2;
}

.testimonial-content {
  background-color: white;
  border-radius: 15px;
  padding: 40px 60px 70px 60px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  text-align: center;
  position: relative;
  border-top: 5px solid #470404;
  transition: transform 0.3s ease;
}

.testimonial-content:hover {
  transform: translateY(-10px);
}

.quote-icon {
  font-size: 2.5rem;
  color: #470404;
  margin-bottom: 20px;
  opacity: 0.8;
}

.testimonial-text {
  font-size: 1.2rem;
  color: #333;
  line-height: 1.8;
  margin-bottom: 30px;
  font-style: italic;
  position: relative;
}

.testimonial-author {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
}

.author-avatar {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid #470404;
  box-shadow: 0 5px 15px rgba(71, 4, 4, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #470404;
  color: white;
}

.author-avatar i {
  font-size: 2rem;
}

.author-info {
  text-align: left;
}

.author-name {
  font-size: 1.2rem;
  font-weight: 700;
  background: linear-gradient(-135deg, #300303, #470404);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 5px;
}

.author-position {
  font-size: 0.9rem;
  color: #696969;
}

.testimonials-slides {
  position: relative;
  min-height: 450px;
  margin-bottom: 30px;
  cursor: grab;
  transition: transform 0.3s ease;
}

.testimonials-slides:active {
  cursor: grabbing;
}

.testimonial-controls {
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.95);
  padding: 15px 25px;
  border-radius: 50px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
}

.control-prev,
.control-next {
  background: white;
  border: 2px solid #470404;
  font-size: 1rem;
  color: #470404;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
}

.control-prev:hover,
.control-next:hover {
  color: white;
  background-color: #470404;
  transform: scale(1.1);
  box-shadow: 0 5px 15px rgba(71, 4, 4, 0.3);
}

.control-indicators {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ddd;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.indicator:hover {
  transform: scale(1.2);
  background-color: #470404;
}

.indicator.active {
  background-color: #470404;
  transform: scale(1.2);
  border-color: white;
  box-shadow: 0 0 10px rgba(71, 4, 4, 0.5);
}

/* Seção de Parceiros */
.partners-section {
  background-color: #f0f0f0;
}

.partners-carousel {
  overflow: hidden;
  margin: 50px 0;
}

.partners-track {
  display: flex;
  gap: 30px;
  animation: scroll 60s linear infinite;
  width: calc((180px + 30px) * 66);
  /* 66 slides total: 33 originais + 33 duplicados */
  height: 220px;
  align-items: center;
}

.partner-slide {
  flex: 0 0 auto;
  width: 180px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-radius: 16px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.06),
    0 4px 16px rgba(0, 0, 0, 0.03),
    0 0 0 1px rgba(71, 4, 4, 0.08);
  padding: 20px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  border: 2px solid rgba(71, 4, 4, 0.1);
  overflow: hidden;
}

.partner-slide::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg,
      transparent,
      rgba(255, 255, 255, 0.4),
      transparent);
  transition: left 0.6s ease;
}

.partner-slide:hover::before {
  left: 100%;
}

/* Retirado scale do hover do slide */
.partner-slide:hover {
  transform: translateY(-8px);
  box-shadow:
    0 20px 40px rgba(0, 0, 0, 0.12),
    0 8px 24px rgba(71, 4, 4, 0.15),
    0 0 0 1px rgba(71, 4, 4, 0.2);
  border-color: rgba(71, 4, 4, 0.3);
}

/* Escala individual aplicada na imagem */
.partner-slide img {
  object-fit: contain;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), filter 0.4s ease;
  position: relative;
  z-index: 2;
  transform: scale(var(--img-scale, 1));
  /* valor base individual */
}

/* Hover da imagem */
.partner-slide img:hover {
  filter: grayscale(0%) brightness(1) saturate(1.1);
  transform: scale(calc(var(--img-scale, 1) * 1.2));
  /* aumenta 20% sobre o tamanho base */
}

/* Escalas individuais dos parceiros */
.partner-1 {
  --img-scale: 0.16;
}

.partner-2 {
  --img-scale: 0.8;
}

.partner-3 {
  --img-scale: 0.7;
}

.partner-4 {
  --img-scale: 0.4;
}

.partner-5 {
  --img-scale: 0.09;
}

.partner-6 {
  --img-scale: 0.8;
}

.partner-7 {
  --img-scale: 0.08;
}

.partner-8 {
  --img-scale: 0.5;
}

.partner-9 {
  --img-scale: 0.04;
}

.partner-10 {
  --img-scale: 0.065;
}

.partner-11 {
  --img-scale: 0.35;
}

.partner-12 {
  --img-scale: 0.065;
}

.partner-13 {
  --img-scale: 0.065;
}

.partner-14 {
  --img-scale: 0.06;
}

.partner-15 {
  --img-scale: 0.55;
}

.partner-16 {
  --img-scale: 0.3;
}

.partner-17 {
  --img-scale: 0.18;
}

.partner-18 {
  --img-scale: 0.15;
}

.partner-19 {
  --img-scale: 0.13;
}

.partner-20 {
  --img-scale: 0.13;
}

.partner-21 {
  --img-scale: 0.065;
}

.partner-22 {
  --img-scale: 0.19;
}

.partner-23 {
  --img-scale: 0.4;
}

.partner-24 {
  --img-scale: 0.5;
}

.partner-25 {
  --img-scale: 0.13;
}

.partner-26 {
  --img-scale: 0.85;
}

.partner-27 {
  --img-scale: 0.35;
}

.partner-28 {
  --img-scale: 0.075;
}

.partner-29 {
  --img-scale: 0.068;
}

.partner-30 {
  --img-scale: 0.025;
}

.partner-31 {
  --img-scale: 0.04;
}

.partner-32 {
  --img-scale: 0.6;
}

.partner-33 {
  --img-scale: 0.35;
}

/* Animação do carrossel de parceiros */
@keyframes scroll {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(calc(-1 * (180px + 30px) * 33));
  }
}

/* Botão secundário */
.partners-action {
  text-align: center;
  margin-top: 30px;
}

.secondary-button {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.8), rgba(240, 240, 240, 0.65));
  backdrop-filter: blur(20px) saturate(160%);
  -webkit-backdrop-filter: blur(20px) saturate(160%);
  color: #470404;
  border: 1px solid rgba(147, 20, 20, 0.35);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.7);
  padding: 12px 25px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 50px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.5);
}

.secondary-button:hover {
  background-color: rgba(71, 4, 4, 0.9);
  border-color: #470404;
  color: white;
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(71, 4, 4, 0.2);
}

.secondary-button i {
  transition: transform 0.3s ease;
}

.secondary-button:hover i {
  transform: translateX(5px);
}

/* Seção de Chamada para Ação */
.cta-section {
  background: linear-gradient(135deg, #470404, #300303);
  color: white;
  position: relative;
  overflow: hidden;
}

.cta-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: repeating-linear-gradient(45deg, rgba(255, 255, 255, 0.08) 0px, rgba(255, 255, 255, 0.08) 1px, transparent 1px, transparent 14px);
  opacity: 0.3;
}

.cta-watermark {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/uni-simbolo-outline-branco.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 1200px;
  opacity: 0.16;
  pointer-events: none;
}

.cta-container {
  text-align: center;
  position: relative;
  z-index: 1;
}

.cta-container h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 20px;
}

.cta-container p {
  font-size: 1.2rem;
  max-width: 700px;
  margin: 0 auto 40px;
  line-height: 1.6;
}

.cta-button {
  background-color: white;
  color: #470404;
  border: none;
  padding: 15px 30px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 50px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.cta-button:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  background-color: #f0f0f0;
}

/* Este CTA fica sobre fundo bordô escuro — vidro claro (branco/cinza
   névoa translúcido) pra manter contraste e ainda ficar coerente com
   o material glass usado no resto do site */
.cta-section .cta-button {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.8), rgba(240, 240, 240, 0.65)) !important;
  backdrop-filter: blur(20px) saturate(160%) !important;
  -webkit-backdrop-filter: blur(20px) saturate(160%) !important;
  border: 1px solid rgba(255, 255, 255, 0.6) !important;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.7) !important;
}

.cta-section .cta-button span,
.cta-section .cta-button i {
  background: none !important;
  -webkit-background-clip: initial !important;
  background-clip: initial !important;
  -webkit-text-fill-color: #470404 !important;
  color: #470404 !important;
}

.cta-button i {
  transition: transform 0.3s ease;
}

.cta-button:hover i {
  transform: translateX(5px);
}

/* Seção de Contato Rápido */
.quick-contact-section {
  background-color: #F0F0F0;
  padding: 100px 0;
  position: relative;
  overflow: hidden;
}

/* Símbolo em rubi sangrando pelo canto inferior esquerdo (diagonal) */
.quick-contact-section::after {
  content: '';
  position: absolute;
  bottom: -399px;
  left: -357px;
  width: 1050px;
  height: 1050px;
  background-image: url('@/assets/uni-simbolo-outline-rubi.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  mask-image: linear-gradient(45deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5) 55%, transparent 85%);
  -webkit-mask-image: linear-gradient(45deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5) 55%, transparent 85%);
  pointer-events: none;
  opacity: 0.14;
  z-index: 0;
}

.quick-contact-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: repeating-linear-gradient(45deg, rgba(240, 240, 240, 0.07) 0px, rgba(240, 240, 240, 0.07) 1px, transparent 1px, transparent 14px);
  pointer-events: none;
  z-index: 0;
}

.quick-contact-container {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  align-items: center;
}

.contact-info {
  text-align: left;
}

.contact-info h2 {
  font-size: 2.2rem;
  font-weight: 700;
  background: linear-gradient(135deg, #300303, #470404);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 20px;
}

.contact-info p {
  font-size: 1.1rem;
  color: #696969;
  margin-bottom: 30px;
  line-height: 1.6;
}

.branch-selector {
  display: flex;
  gap: 15px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.branch-button {
  padding: 12px 25px;
  background-color: rgba(240, 240, 240, 0.55);
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  border: 1.5px solid rgba(71, 4, 4, 0.18);
  border-radius: 50px;
  font-weight: 600;
  font-size: 1rem;
  color: #470404;
  cursor: pointer;
  transition: all 0.3s ease;
  flex: 1;
  min-width: 300px;
  text-align: center;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.5);
}

.branch-button:hover {
  background-color: rgba(240, 240, 240, 0.8);
  border-color: rgba(71, 4, 4, 0.35);
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.branch-button.active {
  background-color: #470404;
  color: white;
  border-color: #470404;
  box-shadow: 0 5px 15px rgba(71, 4, 4, 0.3);
}

.branch-info {
  background-color: #f0f0f0;
  border-radius: 15px;
  padding: 30px;
  margin-bottom: 30px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.branch-info:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.contact-methods {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.contact-method {
  display: flex;
  align-items: center;
  gap: 15px;
}

.contact-method i {
  font-size: 1.5rem;
  color: #470404;
  width: 40px;
  height: 40px;
  background-color: rgba(71, 4, 4, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
}

.contact-method span {
  font-size: 1.1rem;
  color: #333;
  line-height: 1.4;
  flex: 1;
}

.contact-method a {
  font-size: 1.1rem;
  color: #333;
  text-decoration: none;
  line-height: 1.4;
}

.contact-method a:hover {
  color: #470404;
  text-decoration: underline;
}

.email-link {
  font-size: 1.1rem;
  color: #333;
  text-decoration: none;
  transition: color 0.3s ease, background-color 0.3s ease, transform 0.3s ease, padding 0.3s ease;
  position: relative;
  border-radius: 5px;
  line-height: 1.4;
}

.email-link:hover {
  color: #470404;
  background-color: rgba(71, 4, 4, 0.1);
  transform: translateY(-2px);
  padding: 2px 6px;
}

.branch-map {
  height: 640px;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: 5px solid white;
  transition: all 0.3s ease;
}

.branch-map:hover {
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
  transform: translateY(-5px);
}

/* Banner de Cookies */
.cookie-banner {
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  max-width: 1200px;
  margin: 0 auto;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.2);
  z-index: 999;
  animation: slideUp 0.5s ease;
}

.cookie-content {
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  padding: 10px;
  min-height: 60px;
}

.cookie-icon {
  font-size: 2rem;
  color: #470404;
  margin-right: 20px;
}

.cookie-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  text-align: center;
}

.cookie-text h3 {
  margin-bottom: 10px;
  background: linear-gradient(-135deg, #300303, #470404);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-top: 0;
  line-height: 1.2;
  text-align: center;
}

.cookie-text p {
  margin-bottom: 10px;
  color: #696969;
  font-size: 0.9rem;
  text-align: center;
}

.cookie-text a {
  color: #470404;
  text-decoration: none;
  transition: all 0.2s ease;
  font-weight: bold;
}

.cookie-text a:hover {
  color: #931414;
  text-decoration: underline;
}

.cookie-buttons {
  display: flex;
  gap: 10px;
}

.cookie-accept,
.cookie-reject,
.cookie-settings {
  padding: 10px 20px;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.cookie-accept {
  background-color: #470404;
  color: white;
}

.cookie-accept:hover {
  background-color: #931414;
}

.cookie-reject {
  background-color: #6c757d;
  color: white;
}

.cookie-reject:hover {
  background-color: #5a6268;
}

.cookie-settings {
  background-color: #f1f1f1;
  color: #333;
}

.cookie-settings:hover {
  background-color: #e5e5e5;
}

/* Modal de Configurações de Cookies */
.cookie-settings-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

.cookie-settings-content {
  background-color: white;
  border-radius: 10px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);
}

.cookie-settings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;
}

.cookie-settings-intro {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f0f0f0;
  border-radius: 8px;
  border-left: 4px solid #470404;
}

.cookie-settings-intro p {
  margin: 0;
  color: #696969;
  font-size: 0.95rem;
  line-height: 1.5;
  text-align: justify;
  padding-left: 20px;
  padding-right: 20px;
}

.cookie-intro-icon {
  color: #470404;
  font-size: 1.2rem;
  margin-top: 2px;
  margin-left: -25px;
  flex-shrink: 0;
}

.cookie-settings-intro a {
  color: #470404;
  text-decoration: none;
  font-weight: 600;
}

.cookie-settings-intro a:hover {
  text-decoration: underline;
  color: #931414;
}

.cookie-settings-header h3 {
  margin: 0;
  color: #470404;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #696969;
  cursor: pointer;
  transition: color 0.3s ease;
}

.close-button:hover {
  color: #333;
}

.cookie-settings-body {
  padding: 20px;
}

.cookie-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #f0f0f0;
}

.cookie-option:last-child {
  border-bottom: none;
}

.cookie-option-info {
  flex: 1;
}

.cookie-option-info h4 {
  margin: 0 0 5px 0;
  background: linear-gradient(-135deg, #300303, #470404);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.cookie-option-info p {
  margin: 0;
  color: #696969;
  font-size: 0.9rem;
}

.cookie-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.cookie-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked+.slider {
  background-color: #470404;
}

input:focus+.slider {
  box-shadow: 0 0 1px #470404;
}

input:checked+.slider:before {
  transform: translateX(26px);
}

.cookie-switch.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.cookie-settings-footer {
  padding: 20px;
  border-top: 1px solid #f0f0f0;
  text-align: right;
}

.cookie-save {
  padding: 10px 20px;
  background-color: #470404;
  color: white;
  border: none;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.cookie-save:hover {
  background-color: #931414;
}

/* Animações */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bounce {

  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }

  40% {
    transform: translateY(-10px);
  }

  60% {
    transform: translateY(-5px);
  }
}

@keyframes glow {
  from {
    box-shadow: 0 0 10px rgba(71, 4, 4, 0.6);
  }

  to {
    box-shadow: 0 0 20px rgba(71, 4, 4, 0.9), 0 0 30px rgba(255, 255, 255, 0.3);
  }
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(71, 4, 4, 0.7);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(71, 4, 4, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(71, 4, 4, 0);
  }
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-10px);
  }

  100% {
    transform: translateY(0px);
  }
}

.service-icon i,
.stat-icon i {
  animation: float 3s ease-in-out infinite;
}

/* Efeito de brilho para botões */
.secondary-button,
.cta-button {
  position: relative;
  overflow: hidden;
}

.secondary-button::after,
.cta-button::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.7s;
}

.secondary-button:hover::after,
.cta-button:hover::after {
  left: 100%;
}

.stat-number.presence-text {
  font-size: 1.3em;
  line-height: 1.2;
  text-align: center;
}

/* RESPONSIVIDADE */

/* Tablets e telas médias */
@media (max-width: 1200px) {
  .stats-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .quick-contact-container {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .contact-info {
    text-align: center;
  }

  .branch-info {
    background-color: #f0f0f0;
    border-radius: 15px;
    padding: 25px;
    margin: 0 auto 30px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    max-width: 450px;
  }

  .contact-methods {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 400px;
    margin: 0 auto;
  }

  .contact-method {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    width: 100%;
  }

  .contact-method i {
    font-size: 1.5rem;
    color: #470404;
    width: 40px;
    height: 40px;
    background-color: rgba(71, 4, 4, 0.1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
  }

  .contact-method span,
  .contact-method a {
    font-size: 1rem;
    color: #333;
    line-height: 1.4;
    flex: 1;
    text-align: left;
  }

  .branch-selector {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 15px;
    margin-bottom: 30px;
  }

  .branch-button {
    min-width: 500px;
  }
}

@media (max-width: 992px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .hero-content {
    max-width: 84%;
    margin-left: 8%;
  }

  .banner-h2 {
    font-size: 2em;
  }

  .banner-p {
    font-size: 1.05em;
  }

  .branch-selector {
    justify-content: center;
  }

  .branch-info {
    background-color: #f0f0f0;
    border-radius: 15px;
    padding: 25px;
    margin: 0 auto 30px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    max-width: 450px;
  }

  .contact-methods {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 400px;
    margin: 0 auto;
  }

  .contact-method {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    width: 100%;
  }

  .contact-method i {
    font-size: 1.5rem;
    color: #470404;
    width: 40px;
    height: 40px;
    background-color: rgba(71, 4, 4, 0.1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
  }

  .contact-method span,
  .contact-method a {
    font-size: 1rem;
    color: #333;
    line-height: 1.4;
    flex: 1;
    text-align: left;
  }

  .branch-map {
    height: 350px;
  }

  .services-grid {
    grid-template-columns: 1fr;
    gap: 50px;
  }

  .service-card {
    max-width: 700px;
    margin: 0 auto;
  }
}

/* Smartphones */
@media (max-width: 768px) {
  section {
    padding: 60px 0;
  }

  .section-title {
    font-size: 2rem;
  }

  .section-subtitle {
    font-size: 1.1rem;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 18px;
  }

  .stat-card .stat-number {
    font-size: 1.9rem;
  }

  .stat-card .stat-icon {
    width: 60px;
    height: 60px;
    font-size: 1.3rem;
  }

  .stat-card .stat-label {
    font-size: 0.75rem;
  }

  .hero-section {
    height: 100vh;
  }

  .hero-content {
    max-width: 88%;
    margin-left: 6%;
    padding: 20px 15px;
  }

  .banner-h2 {
    font-size: 1.6em;
  }

  .banner-p {
    font-size: 1em;
  }

  .hero-buttons {
    width: 100%;
  }

  .hero-btn {
    flex: 1;
    text-align: center;
  }

  .scroll-indicator {
    padding: 8px 16px;
  }

  .scroll-indicator span {
    font-size: 14px;
  }

  .cookie-content {
    flex-direction: column;
    text-align: center;
  }

  .cookie-icon {
    margin-right: 0;
    margin-bottom: 5px;
  }

  .cookie-buttons {
    margin-top: 5px;
  }

  .cookie-banner {
    border-radius: 10px;
  }

  .testimonial-content {
    padding: 30px 30px 80px 30px;
  }

  .testimonial-controls {
    bottom: -15px;
    padding: 12px 20px;
    gap: 15px;
  }

  .control-prev,
  .control-next {
    width: 30px;
    height: 30px;
    font-size: 0.9rem;
  }

  .stats-section {
    padding: 80px 0;
  }

  /* Em telas menores as duas logos desmaiadas de fundo (canto superior
     esquerdo e inferior direito) se aproximam demais e se sobrepõem no
     meio da seção, formando uma junção feia — some com a segunda,
     mantendo só a do canto superior esquerdo */
  .stats-watermark-2 {
    display: none;
  }

  .services-section {
    padding: 70px 0;
  }

  .service-card {
    max-width: 450px;
    margin: 0 auto;
  }

  .branch-button {
    padding: 10px 20px;
    font-size: 0.9rem;
  }

  .contact-info h2 {
    font-size: 1.8rem;
  }

  .contact-info p {
    font-size: 1rem;
  }

  .branch-map {
    height: 300px;
  }

  .cta-container h2 {
    font-size: 2rem;
  }

  .cta-container p {
    font-size: 1.1rem;
  }
}

@media (max-width: 576px) {
  .cookie-buttons {
    flex-direction: column;
    width: 55%;
  }

  .cookie-accept,
  .cookie-reject,
  .cookie-settings {
    width: 100%;
    margin-bottom: 2px;
  }

  .testimonial-content {
    padding: 25px 20px 70px 20px;
  }

  .testimonial-controls {
    bottom: -10px;
    padding: 10px 15px;
    gap: 12px;
  }

  .control-prev,
  .control-next {
    width: 28px;
    height: 28px;
    font-size: 0.8rem;
  }

  .indicator {
    width: 8px;
    height: 8px;
  }

  .author-avatar {
    width: 40px;
    height: 40px;
  }

  .author-avatar i {
    font-size: 1.2rem;
  }

  .author-name {
    font-size: 1rem;
  }

  .author-position {
    font-size: 0.8rem;
  }

  .testimonial-text {
    font-size: 0.9rem;
  }

  .branch-selector {
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }

  .branch-button {
    min-width: unset;
    width: 100%;
    max-width: 100%;
    padding: 10px 15px;
    font-size: 0.9rem;
    word-wrap: break-word;
    white-space: normal;
    line-height: 1.3;
  }

  .branch-info {
    padding: 20px;
  }

  .contact-method i {
    width: 35px;
    height: 35px;
    font-size: 1.2rem;
  }

  .contact-method span {
    font-size: 0.9rem;
  }

  .branch-map {
    height: 250px;
  }

  .section-title {
    font-size: 1.8rem;
  }

  .section-subtitle {
    font-size: 1rem;
  }

  .service-icon {
    font-size: 2.5rem;
  }

  .service-card h3 {
    font-size: 1.3rem;
  }

  .cta-container h2 {
    font-size: 1.8rem;
  }

  .cta-container p {
    font-size: 1rem;
  }

  .hero-content {
    max-width: 90%;
    margin-left: 5%;
    padding: 15px 10px;
  }

  .banner-h2 {
    font-size: 1.35em;
  }

  .banner-p {
    font-size: 0.95em;
  }

  .hero-btn {
    padding: 12px 22px;
    font-size: 0.9rem;
  }
}

@media (max-width: 400px) {
  .branch-button {
    font-size: 0.8rem;
  }

  .container {
    padding: 0 15px;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .stat-card .stat-number {
    font-size: 1.8rem;
  }

  .stat-card .stat-icon {
    width: 55px;
    height: 55px;
    font-size: 1.3rem;
  }

  .service-content {
    padding: 25px;
  }

  .author-avatar {
    width: 25px;
    height: 25px;
  }

  .author-avatar i {
    font-size: 0.7rem;
  }

  .author-name {
    font-size: 0.9rem;
  }

  .author-position {
    font-size: 0.7rem;
  }

  .cookie-content {
    padding: 20px;
  }

  .cookie-text h3 {
    font-size: 1.1rem;
  }

  .cookie-text p {
    font-size: 0.8rem;
  }

  .hero-content {
    max-width: 92%;
    margin-left: 4%;
    padding: 12px 8px;
  }

  .banner-h2 {
    font-size: 1.2em;
  }
}

/* Melhorias de acessibilidade */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }

  .parallax-container {
    background-attachment: scroll;
  }
}

/* Print styles */
@media print {

  .cookie-banner,
  .cookie-settings-modal,
  .scroll-indicator,
  .testimonial-controls {
    display: none !important;
  }

  .hero-section {
    height: auto;
    min-height: auto;
  }

  .parallax-container {
    background-attachment: scroll;
    position: relative;
  }

  section {
    page-break-inside: avoid;
  }
}

/* Estilos para o ScrollReveal */
.scroll-reveal {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.6s ease;
}

.scroll-reveal.revealed {
  opacity: 1;
  transform: translateY(0);
}

/* Estilos para loading states */
.loading {
  opacity: 0.6;
  pointer-events: none;
}

.loading::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  margin: -10px 0 0 -10px;
  border: 2px solid #470404;
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Estilos para estados de erro */
.error-state {
  color: #dc3545;
  text-align: center;
  padding: 20px;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 5px;
  margin: 20px 0;
}

/* Estilos para estados de sucesso */
.success-state {
  color: #155724;
  text-align: center;
  padding: 20px;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 5px;
  margin: 20px 0;
}

/* Melhorias de performance */
.service-image img,
.partner-slide img {
  will-change: transform;
}

.stat-item,
.service-card,
.testimonial-content {
  will-change: transform;
}

/* Estilos para focus states (acessibilidade) */
button:focus,
.branch-button:focus,
.service-link:focus,
.indicator:focus {
  outline: 2px solid #470404;
  outline-offset: 2px;
}

/* Estilos para high contrast mode */
@media (prefers-contrast: high) {
  .service-overlay {
    background: rgba(0, 0, 0, 0.8);
  }

  .overlay {
    background: rgba(0, 0, 0, 0.8);
  }

  .accent-line {
    background: #470404;
  }
}
</style>

